import type { ReactElement } from "react";
import {
  KanbanScrollFade,
  KanbanScrollFadeSide,
} from "./KanbanScrollFade";
import type { ScrollHintState } from "./useKanbanBoardScroll";

interface KanbanScrollFadesProps {
  scrollHintState: ScrollHintState;
}

export function KanbanScrollFades({
  scrollHintState,
}: KanbanScrollFadesProps): ReactElement {
  return (
    <>
      {scrollHintState.showLeft ? (
        <KanbanScrollFade side={KanbanScrollFadeSide.Left} />
      ) : null}

      {scrollHintState.showRight ? (
        <KanbanScrollFade side={KanbanScrollFadeSide.Right} />
      ) : null}
    </>
  );
}
